import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { setSelectedInitiativeStatuses } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useSelectedInitiativeStatuses } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { Text } from '../../../../ui-library/typography/typography';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { useAvailableInitiativeStatuses } from './initiative-overview.hooks';
import { InitiativeStatusItem } from './initiative-status-item';

export const InitiativeOverview = () => {
  const i18n = useTranslation();
  const selectedInitiativeStatuses = useSelectedInitiativeStatuses();
  const availableStatuses = useAvailableInitiativeStatuses();

  if (!availableStatuses.length) {
    return null;
  }

  return (
    <Stack pb={40}>
      <Text size="small" weight="bold">
        {i18n.t('common.status.status')}
      </Text>
      {availableStatuses.map((statusOption) => (
        <InitiativeStatusItem
          key={statusOption.status}
          status={statusOption.status}
          label={statusOption.label}
          color={statusOption.color}
          isSelected={selectedInitiativeStatuses.includes(statusOption.status)}
        />
      ))}
      <ResetFiltersButton
        onClick={() => setSelectedInitiativeStatuses(availableStatuses.map((status) => status.status))}
      />
    </Stack>
  );
};
